import { inject, InjectionToken } from "@angular/core";
import { SideNavService } from "@app/shared-core/components/side-nav/services/side-nav.service";
import { COMMON_GUARD_OPTIONS } from "@app/shared/auth/constants/permissions.constant";
import { StockTypeRoutePaths } from "../stock-type-route-paths";
import { APP_ROUTE_PATHS } from "@app/app-route-paths";

export const STOCK_TYPE_SIDENAV_LINK = new InjectionToken<void>("STOCK_TYPE_SUB_LINK", {
  providedIn: "root",
  factory: () => {
    const sideNavService = inject(SideNavService);
    sideNavService.addSubMenuItems("setting", [
      {
        id: "other-settings",
        icon: "home",
        label: "OTHER_SETTINGS",
        items: [
          {
            id: "stock-type",
            label: "STOCK_TYPE",
            routerLink: `${StockTypeRoutePaths.ROOT}`,
            permissions: COMMON_GUARD_OPTIONS.STOCK_TYPE.VIEW.permissions,
          },
        ],
      },
    ]);
  },
});
